import React from 'react';
import { connect } from 'react-redux';

class AboutPage extends React.PureComponent {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  }

  render() {
    const { about } = this.props;
    return (
      <main className="about-page">
        {about
        && <div dangerouslySetInnerHTML={{ __html: about }} /> // eslint-disable-line
        }
      </main>
    );
  }
}

const mapStateToProps = state => ({
  about: state.settings.about,
});

export default connect(mapStateToProps)(AboutPage);
